export const Logo = ({ size = 44, className = "" }) => (
    <svg
        viewBox="0 0 64 64"
        width={size}
        height={size}
        className={className}
        aria-label="Gaurav Sankalp Phase-1 Logo"
    >
        <circle cx="32" cy="32" r="30" fill="#0B4F9E" />
        <path
            fill="#F26722"
            d="M32 8 34 26 52 24 38 32 52 40 34 38 32 56 30 38 12 40 26 32 12 24 30 26z"
        />
        <circle cx="32" cy="32" r="6" fill="#FFFFFF" />
        <circle cx="32" cy="32" r="3" fill="#0B4F9E" />
    </svg>
);

export default Logo;
